<template>
  <div>
    <div class="content">
      <main>
        <slot/>
      </main>
      <the-footer />
    </div>
    <flash-notifications />
  </div>
</template>

<script>
import FlashNotifications from './FlashNotifications.vue'
import TheFooter from './TheFooter.vue'

export default {
  name: 'TheContainer',

  components: {
    FlashNotifications,
    TheFooter
  }
}
</script>
